import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    confirmed: {
      color: theme.palette.success.main,
      fontSize: theme.typography.pxToRem(11),
    },

    unconfirmed: {
      color: theme.palette.error.main,
      fontSize: theme.typography.pxToRem(11),
    },

    updateButton: {
      textTransform: 'inherit',
      textAlign: 'right',
      padding: 0,
    },

    listItem: {
      paddingLeft: 34,
      paddingRight: 34,
    },

    capitalize: {
      textTransform: 'capitalize',
    },

    textRight: {
      textAlign: 'right',
    },

    mt10: {
      marginTop: 10,
    },

    mt5: {
      marginTop: 5,
    },

    cardContentPadding: {
      marginTop: -20,
      marginLeft: -32,
      marginRight: -32,
    },

    userList: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      width: '100%',
      alignItems: 'flex-start',
    },

    userListItem: {
      width: '40%',
      padding: '0 4px 8px 0',
    },
  };
});

const listTextStyles = makeStyles((theme) => {
  return {
    primary: {
      fontSize: '13px',
      fontWeight: '400',
      color: '#4D4F5C',
      wordBreak: 'break-word',
    },

    secondary: {
      color: theme.palette.common.lightNavy,
      fontSize: '13px',
      wordBreak: 'break-word',
    },
  };
});

const listItemsStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: '50px',
      wordBreak: 'break-all',
      textAlign: 'end',
    },
  };
});

export { useStyles, listTextStyles, listItemsStyles };
